<template>
	<div class="lai-map">
		<el-dialog class="mapAddress" :title="title" top="0" width="1200px" :fullscreen="true" :visible.sync="visible" @opened="opened" :before-close="handleDialogClose">
			<div :id="mapId" class="mymap"></div>
			<div class="search mb20 searchBar">
				<div class="flex">
					<el-autocomplete
						v-model="map.keyWord"
						:fetch-suggestions="onSearchAddr"
						placeholder="请输入地址关键词"
						@select="onhandleCommand"
						ref="keywordRef"
						clearable
						:debounce="1000"
					></el-autocomplete> 
					<!-- <el-input class="inputcity" style="display:none" placeholder="请输入城市" maxlength="10" v-model="map.inputCityName"></el-input> -->
					<!-- <el-input placeholder="请输入地址关键词,按回车键查询" v-model="map.keyWord" @keyup.enter.native="onSearchAddr" ref="keywordRef"></el-input> -->
					<el-button class="ml20" size="mini" type="danger" @click="onAddrconfirm">确定</el-button>
				</div>
				<!-- <el-dropdown :hide-on-click="false" ref="mapDropDown" class="map-dropdown" trigger="click" @command="onhandleCommand">
					<span class="el-dropdown-link"></span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="item" v-for="(item,index) in map.poiset" :key="index" icon="el-icon-place">{{item.name}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown> -->
			</div>

		</el-dialog>
	</div>
</template>

<script>
	import {
		mapActions
	} from "vuex";
	export default {
		name: 'laiMap',
		props: {
			//触发地图的id标识
			invokeId:{
				type: String,
				default: null
			},
			currentPoint:{
				type: String,
				default: null
			},
			mapId: {
				type: String,
				default: null
			},
			title:{
				type: String,
				default: '选择地址'
			},
			mapVisible: {
				type: Boolean,
				default: null
			}
		},
		computed: {},
		watch: {
			mapVisible: function(val) {
				this.visible = val;
			}
		},
		data() {
			return {
				currenetPosMarker:null,
				visible: false,
				SFMap: window.SFMap,
				map: {
					markerTpl: null,
					mapIns: null,
					vectorLayer: null,
					markersList: [],
					currVo: null,
					poiset: [],
					inputCityName: '深圳市',
					keyWord: '',
					province: '',
					district: '',
					cityCode: '',
					addrDetail: '',
					cityName: '',
					coordinateLon: null,
					coordinateLat: null,
				}
			}
		},
		mounted() {
			
		},
		destroyed() {
			
		},
		methods: {
			...mapActions([
				"getAddrInformationCfg",
				"deleteAddrInformationCfg",
				"deleteAllAddrInformationCfg",
				"queryCitys",
				'addAddressApi',
				'queryAddrByCoordinateApi',
				'queryAddrByKeywordApi',
			]),
			opened(){
				this.initMap();
				this.jumpCurrenetPos();
			},
			handleDialogClose(){
				this.clearMap();
				this.visible = false;
				let result = {};
				result.invokeId = this.invokeId;
				result.data = 'only-close';
				this.$emit('callBackFun', result);
			},
			onSearchAddr(querystring, cb) {
				if (!querystring) {
					this.searchList = []
        			return cb(this.searchList)
				}

				if (this.map.markerTpl) {
					this.map.vectorLayer.removeLayer(this.map.markerTpl);
				}
				if (this.map.keyWord.indexOf('市') > -1) {
					this.map.inputCityName = this.map.keyWord.split('市')[0]
				} else {
					this.map.inputCityName = ''
				}
				this.$message({
					type: 'info',
					message: '查询中...',
					duration: 1000
				});
				this.queryTipByKeyword(cb);
				this.removeMarkersList();
			},
			queryTipByKeyword(cb) {
				let params = {
					'cityName': this.map.inputCityName,
					'keyWord': this.map.keyWord,
					noFailMsg: true
				}
				if (!this.map.keyWord) {
					this.$message({
						type: 'warning',
						message: '请输入地址关键字！'
					});
					this.searchList = []
					return cb(this.searchList)
				}
				this.$refs.keywordRef.activated = true
				this.queryAddrByKeywordApi(params).then(res => {
					const poiset = (res || {}).poiset || []
					this.searchList = poiset.map(ele => {
						return {
							...ele,
							value: ele.name
						}
					})
					cb(this.searchList)
					this.map.poiset = poiset
					this.addMarker(poiset);
					if (!this.searchList.length) {
						this.$message({
							type: 'warning',
							message: '地址不存在，请重试输入地址'
						});
					}
				})
			},
			onAddrconfirm() {
				if (this.map.keyWord && this.searchList && this.searchList.length === 1) {
					this.onhandleCommand(this.searchList[0])
				}
				
				if (!this.map.keyWord || !this.map.coordinate) {
					this.$message({
						type: 'warning',
						message: '请输入关键字搜索，再选取地址！'
					});
					return;
				}
				let data = {};
				data.addrDetail = this.map.addrDetail;
				data.cityCode = this.map.cityCode;
				data.cityName = this.map.cityName;
				data.coordinate = this.map.coordinate;
				data.province = this.map.province;
				data.district = this.map.district;
				this.clearMap();
				this.visible = false;
				let result = {};
				result.invokeId = this.invokeId;
				result.data = data;
				this.$emit('callBackFun', result);
			},
			onhandleCommand(item) {
				let addrDetail = item.adname + item.shortName
				let o = item.lnglat.split(',')
				let coord = [o[1], o[0]]
				let province = ''
				if (item.adname.indexOf('省') > 0) {
					province = item.adname.split('省')[0]
				} else {
					province = ''
				}
				this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
				this.moveMap(coord)
			},
			removeMarkersList() {
				if (this.map.markersList && this.map.markersList.length > 0) {
					for (let i = 0; i < this.map.markersList.length; i++) {
						this.map.vectorLayer.removeLayer(this.map.markersList[i]);
					}
					this.map.markersList = [];
				}
			},
			addMarker(arr) {
				let layer = this.map.vectorLayer;
				arr.forEach((item, index) => {
					let address = item.name;
					let addrDetail = item.adname + item.shortName
					let province = ''
					let o = item.lnglat.split(',')
					let coord = [o[1], o[0]]
					if (index == 0) {
						this.moveMap(coord)
					}
					if (item.adname.indexOf('省') > 0) {
						province = item.adname.split('省')[0] + '省'
					} else {
						province = ''
					}
					let iconMarker = this.SFMap.marker(coord, {
						iconIndex: index + 1
					}).on("click", () => {
						this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
					}).bindTooltip(address);
					layer.addLayer(iconMarker);
					this.map.markersList.push(iconMarker);
				});
			},
			fillMapInfo(addrDetail, cityName, cityCode, coordinate, province, district) {
				this.map.cityName = cityName;
				this.map.addrDetail = addrDetail;
				this.map.cityCode = cityCode;
				this.map.coordinate = coordinate;
				this.map.inputCityName = cityName;
				this.map.keyWord = addrDetail;

				this.map.province = province;
				this.map.district = district;
			},
			moveMap(coord) {
				this.map.mapIns.panTo(coord);
			},
			onMapClick(e) {
				this.clearCurrenetPosMarker();
				this.map.coordinateLat = e.latlng.lat.toFixed(6);
				this.map.coordinateLon = e.latlng.lng.toFixed(6);
				let coordinate = this.map.coordinateLon + ',' + this.map.coordinateLat
				this.$message({
					type: 'info',
					message: '查询中...',
					duration: 1000
				});
				if (this.map.markerTpl) {
					this.map.vectorLayer.removeLayer(this.map.markerTpl);
				}
				this.map.markerTpl = this.SFMap.marker([this.map.coordinateLat, this.map.coordinateLon]);
				this.map.vectorLayer.addLayer(this.map.markerTpl);
				this.queryAddrByCoordinateApi({
					coordinate: coordinate
				}).then(res => {
					this.fillMapInfo(res.name, res.city, res.regcode, coordinate, res.province, res.district)
				}).catch(e => {
					if (e && e.succ === 'fail') {
						this.$message({
							type: "error",
							message: "获取不到地址信息"
						});
					}
				})
			},
			initMap() {
				this.$refs.keywordRef.focus();
				if (!this.map.mapIns) {
					this.map.mapIns = this.SFMap.map(this.mapId, {
						center: [22.524729, 113.940159],
						zoom: 15
					});
					this.map.vectorLayer = this.SFMap.vectorLayer({
						map: this.map.mapIns
					});
					this.map.mapIns.on("click", this.onMapClick);
				}
			},
			clearCurrenetPosMarker(){
				if(this.currenetPosMarker){
					  this.map.vectorLayer.removeLayer(this.currenetPosMarker);
				}
			},
			jumpCurrenetPos(){
				this.clearCurrenetPosMarker();
				let currPointObj = this.getCurrentPointObj();
				if(currPointObj){
					if(currPointObj.coordinate){
					  let lnglatarr = currPointObj.coordinate.split(',')
					  this.currenetPosMarker = this.SFMap.marker([lnglatarr[1],lnglatarr[0]]);
					  this.map.vectorLayer.addLayer(this.currenetPosMarker);
					  this.map.mapIns.panTo([lnglatarr[1],lnglatarr[0]]);
					}
					this.fillMapInfo(currPointObj.addrDetail,currPointObj.cityName,currPointObj.cityCode,currPointObj.coordinate,currPointObj.province,currPointObj.district);
				}
			},
			getCurrentPointObj(){
				if(this.currentPoint){
					return JSON.parse(this.currentPoint);
				}
				return null;
			},
			clearMap() {
				this.map.coordinate = ''
				this.map.keyWord = ''
				if (this.map.markerTpl) {
					this.map.vectorLayer.removeLayer(this.map.markerTpl);
				}
				this.removeMarkersList();
			}
		}
	}
</script>

<style scoped lang="less">
	.lai-map {
		.el-dropdown.map-dropdown {
			position: absolute;
			top: 35px;
			background: red;
			left: 480px;
			z-index: 100;
			color: #fff;
			border-radius: 20px;
		}

		.mymap {
			height: calc(100vh - 80px);
		}

		.ml20 {
			margin-left: 20px;
		}

		.inputcity {
			width: 200px;
		}

		.searchBar {
			position: absolute;
			left: 57px;
			top: 68px;
			right: 20px;
			width: 650px;
			z-index: 99;
		}

		.el-form-item__content {
			width: 225px;
		}

		.newForm {
			margin: 0px auto;
			width: 450px;
		}
	}
</style>
